<template>
  <UCard
    :ui="{
      root: 'relative isolate w-full group hover:ring-2 hover:ring-yellow-400 duration-300 h-full bg-neutral-900/60 backdrop-blur-lg overflow-hidden',
    }"
  >
    <div class="relative z-[2] max-w-prose space-y-1 drop-shadow">
      <USkeleton class="mb-2 h-4 w-1/3" />
      <USkeleton class="h-8 w-2/3" />
      <USkeleton class="mt-2 h-4 w-full" />
      <USkeleton class="h-4 w-3/4" />
      <USkeleton class="mt-4 h-8 w-1/6" />
    </div>
  </UCard>
</template>
